import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { ArrowLeft, Calendar, Shield, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

const ProtectionJoueursNouvellesMesuresAnj = () => {
  return (
    <div className="min-h-screen bg-dark-bg">
      <Header />
      <main className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <Link
            to="/news"
            data-discover="true"
            className="inline-flex items-center text-toxic-green hover:text-opacity-80 mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour aux actualités
          </Link>

          <article className="bg-dark-card border-2 border-gray-800 rounded-2xl p-8 md:p-12">
            <div className="flex items-center text-sm text-gray-400 mb-4">
              <Calendar className="w-4 h-4 mr-2 text-toxic-green" />
              20.11.2025
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              Protection des Joueurs : Les Nouvelles Mesures ANJ
            </h1>

            <div className="prose prose-invert max-w-none">
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                L'Autorité Nationale des Jeux renforce continuellement ses dispositifs de protection des joueurs. Les nouvelles mesures annoncées en 2025 représentent une étape importante dans la sécurisation du marché des paris en ligne. Ces outils et ces obligations visent à mieux protéger les parieurs, surtout ceux qui pourraient être vulnérables, tout en préservant la liberté de ceux qui parient de manière responsable.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Les Nouveaux Outils d'Auto-Exclusion
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les outils d'auto-exclusion existants (24 heures, 7 jours, 30 jours, exclusion définitive) sont complétés par de nouvelles options plus courtes. Vous pouvez désormais vous exclure pour 1 heure, 6 heures, ou 12 heures. Ces pauses courtes peuvent être cruciales pour éviter les décisions impulsives sans avoir à s'exclure pour une journée complète.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ces pauses courtes sont particulièrement utiles si vous sentez que vous êtes sur le point de faire un pari impulsif ou si vous avez perdu plusieurs paris d'affilée et que vous ressentez l'envie de "rattraper". Prendre une pause d'une heure peut suffire pour retrouver votre calme et votre jugement. C'est un outil de prévention précoce, avant que les problèmes ne s'aggravent.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                L'activation de ces pauses est simplifiée. Un simple clic depuis votre compte, et vous êtes immédiatement exclu pour la période choisie. Aucune justification n'est demandée, et la décision est irréversible pendant la période choisie. Cela évite les hésitations qui pourraient vous faire changer d'avis.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Les Limites de Dépôt Renforcées
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les nouvelles réglementations imposent des limites de dépôt par défaut plus strictes pour les nouveaux comptes. Pendant les 30 premiers jours, vous ne pouvez pas déposer plus de 500€ par mois, sauf demande explicite de votre part après une période de réflexion de 48 heures. Cette mesure vise à protéger les nouveaux parieurs qui pourraient être tentés de déposer des montants importants sous l'effet de l'excitation.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Cette limitation peut être prolongée indéfiniment si vous le souhaite. Si vous préférez maintenir une limite basse pour vous protéger, vous pouvez le faire. Pour les parieurs expérimentés qui ouvrent un nouveau compte, cette limitation peut être levée rapidement après vérification d'identité et confirmation de l'expérience, mais la période de réflexion de 48 heures reste obligatoire.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les limites peuvent aussi être ajustées à la baisse à tout moment, mais les augmentations nécessitent toujours une période de réflexion. Cela vous protège contre les décisions impulsives d'augmenter vos limites après un gain ou sous l'effet de l'excitation.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Les Outils de Suivi Personnalisés
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Toutes les plateformes agréées doivent désormais proposer des outils de suivi personnalisés qui vous permettent de voir votre historique de dépôts, de mises, et de gains sur différentes périodes. Ces outils aident à prendre conscience de vos habitudes et à identifier d'éventuels problèmes avant qu'ils ne s'aggravent.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Vous pouvez voir combien vous avez déposé sur la dernière semaine, le dernier mois, ou la dernière année. Vous pouvez voir combien vous avez misé, combien vous avez gagné, et votre solde net. Ces données objectives peuvent révéler des tendances que vous n'aviez pas remarquées subjectivement.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ces outils peuvent aussi vous aider à mieux gérer votre bankroll. En voyant vos dépôts et vos mises sur différentes périodes, vous pouvez identifier les moments où vous dépensez plus et ajuster votre stratégie en conséquence. C'est un outil de gestion, pas seulement de protection.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Les Alertes et Notifications
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les plateformes doivent désormais envoyer des alertes automatiques si vous dépassez certains seuils. Par exemple, si vous dépassez votre limite de dépôt mensuelle habituelle, ou si vous pariez pendant une période prolongée, vous recevrez une notification qui vous rappelle vos limites et vous invite à faire une pause.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ces alertes ne sont pas punitives - elles sont informatives. Elles vous rappellent simplement vos propres limites et vous donnent l'opportunité de réfléchir avant de continuer. Vous pouvez ignorer l'alerte et continuer, mais elle vous aura au moins fait prendre conscience de votre comportement.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                L'Interdiction Volontaire Renforcée
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Le système d'interdiction volontaire de l'ANJ est renforcé. Si vous vous inscrivez à ce système, vous ne pourrez pas créer de compte ou parier sur aucune plateforme agréée en France pendant au moins 3 ans. Cette mesure radicale est disponible pour ceux qui ont un problème sérieux et qui ont besoin d'une protection complète.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                L'inscription à ce système est gratuite et peut être faite directement sur le site de l'ANJ. Une fois inscrit, toutes les plateformes agréées sont informées et doivent refuser votre inscription ou fermer votre compte si vous en avez déjà un. C'est une mesure de protection totale, mais elle est irréversible pendant la période choisie.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Comment Utiliser Ces Outils
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Ces outils ne sont utiles que si vous les utilisez. Prenez le temps de configurer vos limites dès l'ouverture de votre compte. Fixez des limites réalistes basées sur votre budget, et respectez-les. Si vous sentez que vous avez besoin d'une pause, utilisez les outils d'auto-exclusion, même pour une courte période.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Consultez régulièrement vos outils de suivi. Ne les ignorez pas - ils peuvent révéler des tendances importantes. Si vous voyez que vos dépôts augmentent régulièrement, ou que vous pariez plus souvent, prenez le temps de réfléchir à ce que cela signifie et ajustez votre comportement si nécessaire.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Si vous recevez des alertes, ne les ignorez pas automatiquement. Prenez le temps de réfléchir à ce qu'elles signifient. Si vous dépassez régulièrement vos limites, peut-être que ces limites ne sont pas adaptées, ou peut-être que vous avez besoin d'une pause. L'important est de rester conscient de votre comportement.
              </p>

              <div className="bg-toxic-green/10 border border-toxic-green/30 rounded-xl p-6 mt-12">
                <h3 className="text-2xl font-bold mb-4 text-white flex items-center">
                  <Shield className="w-6 h-6 text-toxic-green mr-3" />
                  Outils Disponibles
                </h3>
                <ul className="space-y-3 text-gray-300">
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Auto-exclusion : 1h, 6h, 12h, 24h, 7j, 30j, ou définitive</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Limites de dépôt configurables avec période de réflexion pour les augmentations</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Outils de suivi personnalisés pour analyser vos habitudes</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Alertes automatiques si vous dépassez certains seuils</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Interdiction volontaire ANJ pour une protection totale</span>
                  </li>
                </ul>
              </div>
            </div>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ProtectionJoueursNouvellesMesuresAnj;

